(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frucare-home-feature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('frucare-home-motion')) {
  customElements.define('frucare-home-motion', class extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-motion-toggle]');
      if (!this.toggle || this.onToggle) return;
      this.onToggle = () => {
        const paused = this.toggleAttribute('data-motion-paused');
        this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      };
      this.toggle.addEventListener('click', this.onToggle);
    }
    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.onToggle);
      this.onToggle = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frucare-pairings-teaser"] && !Shopify.designMode) return;
  try {
    
/* FruCare Book Runtime V40. Shared, guarded, no third-party dependency. */
(function installFruCareBookRuntime(window) {
  'use strict';
  if (window.FruCareBookRuntime && window.FruCareBookRuntime.version >= 40) return;
  const document = window.document;
  const turns = new WeakMap();
  const boundedPage = (page, total) => Math.min(total, Math.max(1, Math.round(Number(page) || 1)));

  function spreadPages(page, desktop, total = 40) {
    total = Math.max(1, Math.round(Number(total) || 40));
    page = boundedPage(page, total);
    if (!desktop || page === 1 || page === total) return [page];
    const left = page % 2 === 0 ? page : page - 1;
    return [left, left + 1].filter(value => value > 1 && value < total);
  }

  function orderPages(current, total = 40, direction = 0) {
    total = Math.max(1, Math.round(Number(total) || 40));
    current = boundedPage(current, total);
    const pages = [current];
    const add = page => { if (page >= 1 && page <= total && !pages.includes(page)) pages.push(page); };
    if (!direction) {
      for (let distance = 1; pages.length < total; distance += 1) {
        add(current + distance);
        add(current - distance);
      }
    } else {
      const step = direction > 0 ? 1 : -1;
      let forward = 1;
      let backward = 1;
      while (pages.length < total) {
        for (let slot = 0; slot < 3; slot += 1) add(current + step * forward++);
        add(current - step * backward++);
      }
    }
    return pages;
  }

  function createQueue({ urlFor, maxConcurrent = 2, timeoutMs = 20000 } = {}) {
    if (typeof urlFor !== 'function') throw new TypeError('urlFor must be a function.');
    const backgroundLimit = Math.max(1, Math.min(3, Math.round(Number(maxConcurrent) || 2)));
    const totalLimit = backgroundLimit + 1;
    const timeout = Math.max(100, Number(timeoutMs) || 20000);
    const entries = new Map();
    const loading = new Set();
    let urgent = [];
    let background = [];
    let desired = new Set();
    let disposed = false;
    let pumping = false;
    const abortError = message => { const error = new Error(message); error.name = 'AbortError'; return error; };
    const getUrl = page => {
      const url = String(urlFor(page) || '');
      if (!url) throw new TypeError('A book page needs an image URL.');
      return url;
    };
    const detach = entry => {
      if (entry.timer) window.clearTimeout(entry.timer);
      entry.timer = null;
      if (entry.image) { entry.image.onload = null; entry.image.onerror = null; }
    };
    function makeEntry(page, url) {
      const entry = { page, url, state: 'queued', urgent: false, attempt: 0, image: null, timer: null };
      entry.promise = new Promise((resolve, reject) => { entry.resolve = resolve; entry.reject = reject; });
      // Background requests have no outside consumer. Consumers still receive the original rejection.
      entry.promise.catch(() => {});
      entries.set(url, entry);
      return entry;
    }
    function settleFailure(entry, error) {
      if (disposed || entry.state !== 'loading') return;
      detach(entry);
      if (entry.image) entry.image.src = '';
      loading.delete(entry);
      if (entry.attempt < 2 && (entry.urgent || desired.has(entry.url))) {
        entry.state = 'queued';
        if (entry.urgent) urgent.unshift(entry);
        else background.unshift(entry.url);
      } else {
        entry.state = 'error';
        entry.reject(error);
      }
      pump();
    }
    function start(entry) {
      entry.state = 'loading';
      entry.attempt += 1;
      const image = new window.Image();
      entry.image = image;
      loading.add(entry);
      image.decoding = 'async';
      image.fetchPriority = entry.urgent ? 'high' : 'low';
      entry.timer = window.setTimeout(() => {
        if (entry.image === image) settleFailure(entry, new Error('The book page took too long to load.'));
      }, timeout);
      image.onerror = () => {
        if (entry.image === image) settleFailure(entry, new Error('The book page could not be loaded.'));
      };
      image.onload = async () => {
        try {
          if (entry.image !== image) return;
          if (typeof image.decode === 'function') await image.decode();
          if (disposed || entry.state !== 'loading' || entry.image !== image) return;
          if ('naturalWidth' in image && image.naturalWidth === 0) throw new Error('The book page is empty.');
          detach(entry);
          loading.delete(entry);
          entry.state = 'ready';
          entry.resolve({ url: entry.url, image });
          pump();
        } catch (error) {
          // A decode from an earlier, timed-out attempt must not fail the replacement request.
          if (entry.image === image) settleFailure(entry, error);
        }
      };
      image.src = entry.url;
    }
    function takeUrgent() {
      while (urgent.length) {
        const entry = urgent.shift();
        if (entry.state === 'queued') return entry;
      }
      return null;
    }
    function takeBackground() {
      while (background.length) {
        const entry = entries.get(background.shift());
        if (entry && entry.state === 'queued' && !entry.urgent) return entry;
      }
      return null;
    }
    function pump() {
      if (disposed || pumping) return;
      pumping = true;
      try {
        while (loading.size < totalLimit) {
          let entry = takeUrgent();
          if (!entry) {
            const activeBackground = [...loading].filter(item => !item.urgent).length;
            if (document.hidden || activeBackground >= backgroundLimit) break;
            entry = takeBackground();
          }
          if (!entry) break;
          start(entry);
        }
      } finally { pumping = false; }
    }
    function ensure(page) {
      if (disposed) return Promise.reject(abortError('The book loader was disposed.'));
      let url;
      try { url = getUrl(page); } catch (error) { return Promise.reject(error); }
      let entry = entries.get(url);
      if (!entry || entry.state === 'error') entry = makeEntry(page, url);
      if (entry.state !== 'ready') {
        entry.urgent = true;
        if (entry.image) entry.image.fetchPriority = 'high';
        if (entry.state === 'queued' && !urgent.includes(entry)) urgent.push(entry);
        if (entry.state === 'queued' && loading.size >= totalLimit) {
          const obsolete = [...loading].reverse().find(item => !item.urgent);
          if (obsolete) {
            detach(obsolete);
            const image = obsolete.image;
            obsolete.image = null;
            obsolete.attempt = Math.max(0, obsolete.attempt - 1);
            loading.delete(obsolete);
            if (image) image.src = '';
            if (desired.has(obsolete.url)) {
              obsolete.state = 'queued';
              if (!background.includes(obsolete.url)) background.push(obsolete.url);
            } else {
              obsolete.state = 'cancelled';
              obsolete.reject(abortError('The pending background priority changed.'));
              entries.delete(obsolete.url);
            }
          }
        }
        pump();
      }
      return entry.promise;
    }
    function prioritize(pages) {
      if (disposed) return;
      urgent = [];
      for (const entry of entries.values()) {
        entry.urgent = false;
        if (entry.state === 'loading' && entry.image) entry.image.fetchPriority = 'low';
      }
      const next = [];
      const seen = new Set();
      for (const page of pages || []) {
        let url;
        try { url = getUrl(page); } catch (_) { continue; }
        if (seen.has(url)) continue;
        seen.add(url);
        let entry = entries.get(url);
        if (!entry) entry = makeEntry(page, url);
        // Failed background images wait for a deliberate ensure() retry, avoiding endless retries.
        if (entry.state === 'queued' && !entry.urgent) next.push(url);
      }
      desired = seen;
      for (const [url, entry] of entries) {
        if (entry.state === 'queued' && !entry.urgent && !seen.has(url)) {
          entry.state = 'cancelled';
          entry.reject(abortError('The pending background priority changed.'));
          entries.delete(url);
        }
      }
      background = next;
      pump();
    }
    const onVisibility = () => { if (!document.hidden) pump(); };
    document.addEventListener('visibilitychange', onVisibility);
    function dispose() {
      if (disposed) return;
      disposed = true;
      document.removeEventListener('visibilitychange', onVisibility);
      for (const entry of entries.values()) {
        detach(entry);
        if (entry.state !== 'ready' && entry.state !== 'error' && entry.state !== 'cancelled') {
          entry.state = 'cancelled';
          entry.reject(abortError('The book loader was disposed.'));
          if (entry.image) entry.image.src = '';
        }
      }
      entries.clear(); loading.clear(); urgent = []; background = []; desired.clear();
    }
    return { ensure, prioritize, dispose };
  }

  function visualClone(node) {
    const clone = node.cloneNode(true);
    const originals = node.matches && node.matches('img') ? [node] : [...node.querySelectorAll('img')];
    const images = clone.matches && clone.matches('img') ? [clone] : [...clone.querySelectorAll('img')];
    images.forEach((image, index) => {
      image.removeAttribute('srcset'); image.removeAttribute('sizes');
      image.src = originals[index].currentSrc || originals[index].src;
      image.loading = 'eager';
    });
    [clone, ...clone.querySelectorAll('[id]')].forEach(element => element.removeAttribute('id'));
    clone.setAttribute('aria-hidden', 'true');
    Object.assign(clone.style, { width: '100%', height: '100%', maxWidth: 'none', maxHeight: 'none', margin: '0', boxSizing: 'border-box', boxShadow: 'none' });
    return clone;
  }

  function turn(container, nextNodes, direction = 1, { spread = false, duration = 440 } = {}) {
    const previousTurn = turns.get(container);
    if (previousTurn) previousTurn();
    const nodes = Array.isArray(nextNodes) ? nextNodes : [nextNodes];
    const oldNodes = [...container.children];
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canAnimate = !reduced && direction && oldNodes.length && typeof container.animate === 'function';
    const bounds = container.getBoundingClientRect();
    const oldRects = oldNodes.map(node => node.getBoundingClientRect());
    const snapshots = canAnimate ? oldNodes.map(visualClone) : [];
    container.dataset.count = String(nodes.length);
    container.classList.toggle('is-single', nodes.length === 1);
    const frontCover = spread && nodes.length === 1 && Number(nodes[0].dataset.page || nodes[0].dataset.fptPage) === 1;
    const backCover = spread && nodes.length === 1 && !frontCover;
    container.style.setProperty('--frucare-shadow-duration', `${canAnimate ? duration : 0}ms`);
    container.style.setProperty('--frucare-shadow-left', frontCover ? '50%' : '0%');
    container.style.setProperty('--frucare-shadow-right', backCover ? '50%' : '0%');
    container.replaceChildren(...nodes);
    if (!canAnimate || bounds.width < 1 || bounds.height < 1) return Promise.resolve();
    const newRects = nodes.map(node => node.getBoundingClientRect());
    const forward = direction > 0;
    const activeIndex = forward ? oldNodes.length - 1 : 0;
    const rect = oldRects[activeIndex];
    const originalStyle = { position: container.style.position, perspective: container.style.perspective, isolation: container.style.isolation };
    if (window.getComputedStyle(container).position === 'static') container.style.position = 'relative';
    container.style.perspective = '1500px';
    container.style.isolation = 'isolate';
    const overlays = [];
    const concealed = [];
    const animations = [];
    const createLayer = pageRect => {
      const layer = document.createElement('div');
      layer.setAttribute('aria-hidden', 'true');
      layer.setAttribute('inert', '');
      layer.setAttribute('data-frucare-turn-layer', '');
      Object.assign(layer.style, {
        position: 'absolute', left: `${pageRect.left - bounds.left}px`, top: `${pageRect.top - bounds.top}px`,
        width: `${pageRect.width}px`, height: `${pageRect.height}px`, pointerEvents: 'none', zIndex: '4',
        margin: '0', boxSizing: 'border-box'
      });
      container.appendChild(layer); overlays.push(layer); return layer;
    };
    const front = createLayer(rect);
    Object.assign(front.style, { transformOrigin: forward ? 'left center' : 'right center', backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden', willChange: 'transform' });
    front.appendChild(snapshots[activeIndex]);
    if (spread) {
      const opposite = forward ? 0 : nodes.length - 1;
      const back = createLayer(newRects[opposite]);
      Object.assign(back.style, { transformOrigin: forward ? 'right center' : 'left center', backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden', willChange: 'transform', transform: `rotateY(${forward ? 180 : -180}deg)` });
      const reverseFace = visualClone(nodes[opposite]);
      reverseFace.style.visibility = 'visible';
      back.appendChild(reverseFace);
      concealed.push([nodes[opposite], nodes[opposite].style.visibility]);
      nodes[opposite].style.visibility = 'hidden';
      animations.push(back.animate([
        { transform: `rotateY(${forward ? 180 : -180}deg)` },
        { transform: 'rotateY(0deg)' }
      ], { duration, easing: 'cubic-bezier(.25,.65,.25,1)', fill: 'forwards' }));
      oldNodes.forEach((node, index) => {
        if (index === activeIndex) return;
        const stationary = createLayer(oldRects[index]);
        stationary.style.zIndex = '3'; stationary.appendChild(snapshots[index]);
      });
    }
    const shadow = document.createElement('div');
    Object.assign(shadow.style, { position: 'absolute', inset: '0', background: forward ? 'linear-gradient(90deg,rgba(40,25,12,.3),transparent 55%)' : 'linear-gradient(270deg,rgba(40,25,12,.3),transparent 55%)', pointerEvents: 'none', backfaceVisibility: 'hidden', opacity: '0' });
    front.appendChild(shadow);
    animations.push(shadow.animate([{ opacity: 0 }, { opacity: 0.9, offset: 0.45 }, { opacity: 0 }], { duration, fill: 'forwards' }));
    animations.push(front.animate(spread ? [
      { transform: 'rotateY(0deg)' },
      { transform: `rotateY(${forward ? -180 : 180}deg)` }
    ] : [
      { transform: 'scaleX(1)', opacity: 1 },
      { transform: 'scaleX(.06)', opacity: 0 }
    ], { duration, easing: 'cubic-bezier(.25,.65,.25,1)', fill: 'forwards' }));
    return new Promise(resolve => {
      let finished = false;
      let timer;
      const cleanup = () => {
        if (finished) return;
        finished = true;
        if (timer) window.clearTimeout(timer);
        concealed.forEach(([node, visibility]) => { node.style.visibility = visibility; });
        overlays.forEach(layer => layer.remove());
        animations.forEach(animation => animation.cancel());
        Object.assign(container.style, originalStyle);
        if (turns.get(container) === cleanup) turns.delete(container);
        resolve();
      };
      turns.set(container, cleanup);
      timer = window.setTimeout(cleanup, duration + 180);
      Promise.allSettled(animations.map(animation => animation.finished)).then(cleanup);
    });
  }

  window.FruCareBookRuntime = { version: 40, createQueue, orderPages, spreadPages, turn };
})(window);

  if (!customElements.get('frucare-pairings-teaser')) {
    customElements.define('frucare-pairings-teaser', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.observer) return;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.observer = null;
            this.activate();
          }, { rootMargin: '700px 0px' });
          this.observer.observe(this);
        } else {
          this.activate();
        }
      }
      activate() {
        if (this.controller) return;
        try {
          this.pages = JSON.parse(this.querySelector('[data-fpt-catalog]').textContent);
          this.words = JSON.parse(this.querySelector('[data-fpt-words]').textContent);
        } catch (_) { return; }
        if (!Array.isArray(this.pages) || !this.pages.length || !window.FruCareBookRuntime) return;
        this.runtime = window.FruCareBookRuntime;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.book = this.querySelector('[data-fpt-book]');
        this.sheets = this.querySelector('[data-fpt-pages]');
        this.cta = this.querySelector('[data-fpt-cta]');
        this.previous = this.querySelector('[data-fpt-previous]');
        this.next = this.querySelector('[data-fpt-next]');
        this.counter = this.querySelector('[data-fpt-count]');
        this.error = this.querySelector('[data-fpt-image-error]');
        this.stage = this.querySelector('[data-fpt-swipe]');
        this.desktopQuery = window.matchMedia('(min-width: 900px)');
        this.desktop = this.desktopQuery.matches;
        this.currentPage = this.desiredPage = 1;
        this.requestVersion = 0;
        this.committedVersion = -1;
        this.suppressClickUntil = 0;
        this.hasInteracted = false;
        this.makeQueue();
        this.previous.hidden = false;
        this.next.hidden = false;
        this.counter.hidden = false;
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.stage.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, { signal });
        this.book.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.book.addEventListener('click', event => {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          const leaf = event.target.closest('[data-fpt-page]');
          if (leaf) this.book.href = this.pageHref(Number(leaf.dataset.fptPage));
        }, { signal });
        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || window.visualViewport?.scale > 1.05) { this.pointer = null; return; }
          if (event.button !== 0 || event.target.closest('button')) return;
          this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now(), moved: false };
        }, { signal, passive: true });
        this.stage.addEventListener('pointermove', event => {
          if (event.pointerType === 'mouse') {
            this.classList.add('is-pointer-active');
            clearTimeout(this.pointerActivityTimer);
            this.pointerActivityTimer = setTimeout(() => this.classList.remove('is-pointer-active'), 1200);
          }
          if (!this.pointer || event.pointerId !== this.pointer.id) return;
          if (Math.hypot(event.clientX - this.pointer.x, event.clientY - this.pointer.y) > 12) this.pointer.moved = true;
        }, { signal, passive: true });
        window.addEventListener('pointerup', event => {
          if (!this.pointer || event.pointerId !== this.pointer.id) return;
          const pointer = this.pointer;
          this.pointer = null;
          const dx = event.clientX - pointer.x;
          const dy = event.clientY - pointer.y;
          if (pointer.moved || Math.hypot(dx, dy) > 12) this.suppressClickUntil = performance.now() + 600;
          if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.3 && performance.now() - pointer.time < 1400) this.move(dx < 0 ? 1 : -1);
        }, { signal, passive: true });
        window.addEventListener('pointercancel', event => {
          if (this.pointer && event.pointerId === this.pointer.id) {
            this.pointer = null;
            this.suppressClickUntil = performance.now() + 600;
          }
        }, { signal, passive: true });
        window.addEventListener('resize', () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.resizeBook(), 120);
        }, { signal, passive: true });
        this.desktopQuery.addEventListener('change', () => this.resizeBook(), { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') this.queue?.prioritize([]);
          else this.prioritize();
        }, { signal });
        this.request(1, 0);
      }
      makeQueue() {
        this.queue?.dispose();
        const width = (this.book.clientWidth || (this.desktop ? 576 : 304)) / (this.desktop ? 2 : 1);
        const pixels = width * Math.min(window.devicePixelRatio || 1, 2);
        this.imageWidth = [360, 480, 640, 800, 1000].find(size => size >= pixels) || 1000;
        const preparedWidth = this.imageWidth;
        this.queue = this.runtime.createQueue({
          urlFor: page => {
            const source = new URL(this.pages[page - 1].imageUrl);
            source.searchParams.set('width', preparedWidth);
            return source.href;
          },
          maxConcurrent: 2
        });
      }
      resizeBook() {
        if (!this.controller) return;
        const desktop = this.desktopQuery.matches;
        const modeChanged = this.desktop !== desktop;
        const pixels = (this.book.clientWidth || 304) / (desktop ? 2 : 1) * Math.min(window.devicePixelRatio || 1, 2);
        const width = [360, 480, 640, 800, 1000].find(size => size >= pixels) || 1000;
        if (!modeChanged && width === this.imageWidth) return;
        this.desktop = desktop;
        this.makeQueue();
        this.request(this.desiredPage, 0);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.controller?.abort();
        this.controller = null;
        this.requestVersion = (this.requestVersion || 0) + 1;
        this.wakePreparation?.();
        this.wakePreparation = null;
        this.pointer = null;
        clearTimeout(this.pressTimer);
        clearTimeout(this.resizeTimer);
        clearTimeout(this.pointerActivityTimer);
        this.queue?.dispose();
      }
      pageHref(page) {
        return this.dataset.pairingsUrl + '#p=' + String(page).padStart(2, '0');
      }
      move(direction) {
        if (!this.controller) return;
        const spread = this.runtime.spreadPages(this.desiredPage, this.desktop, this.pages.length);
        const target = direction > 0 ? spread[spread.length - 1] + 1 : spread[0] - 1;
        if (target < 1 || target > this.pages.length) return;
        this.hasInteracted = true;
        const button = direction < 0 ? this.previous : this.next;
        this.previous.classList.remove('is-pressed');
        this.next.classList.remove('is-pressed');
        void button.offsetWidth;
        button.classList.add('is-pressed');
        clearTimeout(this.pressTimer);
        this.pressTimer = setTimeout(() => button.classList.remove('is-pressed'), 300);
        this.request(target, direction);
      }
      prioritize() {
        if (!this.queue || document.visibilityState === 'hidden') return;
        const visible = this.runtime.spreadPages(this.desiredPage, this.desktop, this.pages.length);
        const ordered = [...visible, ...this.runtime.orderPages(this.desiredPage, this.pages.length, this.direction || 0).filter(page => !visible.includes(page))];
        this.queue.prioritize(this.hasInteracted ? ordered : ordered.slice(0, 6));
      }
      request(page, direction) {
        this.desiredPage = Math.max(1, Math.min(this.pages.length, page));
        this.direction = direction;
        this.requestVersion += 1;
        this.wakePreparation?.();
        this.wakePreparation = null;
        const visible = this.runtime.spreadPages(this.desiredPage, this.desktop, this.pages.length);
        this.previous.disabled = visible[0] === 1;
        this.next.disabled = visible[visible.length - 1] === this.pages.length;
        this.error.hidden = true;
        this.prioritize();
        this.processRequests();
      }
      async processRequests() {
        if (this.processing) return;
        this.processing = true;
        try {
          while (this.controller && this.committedVersion !== this.requestVersion) {
            const version = this.requestVersion;
            const target = this.desiredPage;
            const desktop = this.desktop;
            const direction = this.direction;
            const queue = this.queue;
            const visible = this.runtime.spreadPages(target, desktop, this.pages.length);
            this.book.setAttribute('aria-busy', 'true');
            let wake;
            const superseded = new Promise(resolve => {
              wake = () => resolve({ stale: true });
              this.wakePreparation = wake;
            });
            const preparation = (async () => {
              const ready = await Promise.all(visible.map(page => queue.ensure(page)));
              const nodes = await Promise.all(ready.map(async (loaded, index) => {
                const page = this.pages[visible[index] - 1];
                const img = loaded.image.cloneNode();
                img.removeAttribute('srcset');
                img.removeAttribute('sizes');
                img.loading = 'eager';
                img.decoding = 'async';
                img.width = 1000;
                img.height = 1410;
                img.draggable = false;
                img.alt = this.words.imageAlt.replace('__TITLE__', page.title).replace('__PAGE__', page.page);
                img.setAttribute('data-fpt-image', '');
                if (img.decode) await img.decode();
                const leaf = document.createElement('span');
                leaf.className = 'fc-pairings-teaser__leaf';
                leaf.dataset.fptPage = page.page;
                leaf.append(img);
                return leaf;
              }));
              return nodes;
            })().then(nodes => ({ nodes }), error => ({ error }));
            const result = await Promise.race([preparation, superseded]);
            if (this.wakePreparation === wake) this.wakePreparation = null;
            if (result.stale || version !== this.requestVersion || !this.controller) continue;
            if (result.error) {
              this.error.hidden = false;
              this.committedVersion = version;
              this.desiredPage = this.currentPage;
              const displayed = this.runtime.spreadPages(this.currentPage, this.desktop, this.pages.length);
              this.previous.disabled = displayed[0] === 1;
              this.next.disabled = displayed[displayed.length - 1] === this.pages.length;
              this.prioritize();
              this.book.removeAttribute('aria-busy');
              break;
            }
            const nodes = result.nodes;
            if (!this.controller || version !== this.requestVersion) continue;
            const turning = this.runtime.turn(this.sheets, nodes, direction, { spread: desktop });
            this.currentPage = target;
            this.committedVersion = version;
            this.counter.textContent = this.words.pageCount.replace('__PAGE__', visible.join(' + '));
            this.book.href = this.pageHref(target);
            this.cta.href = this.pageHref(target);
            this.dataset.currentPage = target;
            this.dataset.visiblePages = visible.join(',');
            this.book.removeAttribute('aria-busy');
            await turning;
          }
        } finally {
          this.processing = false;
        }
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frucare-pairings"] && !Shopify.designMode) return;
  try {
    
(function installFruCareBookRuntime(window) {
  'use strict';
  if (window.FruCareBookRuntime && window.FruCareBookRuntime.version >= 40) return;
  const document = window.document;
  const turns = new WeakMap();
  const boundedPage = (page, total) => Math.min(total, Math.max(1, Math.round(Number(page) || 1)));

  function spreadPages(page, desktop, total = 40) {
    total = Math.max(1, Math.round(Number(total) || 40));
    page = boundedPage(page, total);
    if (!desktop || page === 1 || page === total) return [page];
    const left = page % 2 === 0 ? page : page - 1;
    return [left, left + 1].filter(value => value > 1 && value < total);
  }

  function orderPages(current, total = 40, direction = 0) {
    total = Math.max(1, Math.round(Number(total) || 40));
    current = boundedPage(current, total);
    const pages = [current];
    const add = page => { if (page >= 1 && page <= total && !pages.includes(page)) pages.push(page); };
    if (!direction) {
      for (let distance = 1; pages.length < total; distance += 1) {
        add(current + distance);
        add(current - distance);
      }
    } else {
      const step = direction > 0 ? 1 : -1;
      let forward = 1;
      let backward = 1;
      while (pages.length < total) {
        for (let slot = 0; slot < 3; slot += 1) add(current + step * forward++);
        add(current - step * backward++);
      }
    }
    return pages;
  }

  function createQueue({ urlFor, maxConcurrent = 2, timeoutMs = 20000 } = {}) {
    if (typeof urlFor !== 'function') throw new TypeError('urlFor must be a function.');
    const backgroundLimit = Math.max(1, Math.min(3, Math.round(Number(maxConcurrent) || 2)));
    const totalLimit = backgroundLimit + 1;
    const timeout = Math.max(100, Number(timeoutMs) || 20000);
    const entries = new Map();
    const loading = new Set();
    let urgent = [];
    let background = [];
    let desired = new Set();
    let disposed = false;
    let pumping = false;
    const abortError = message => { const error = new Error(message); error.name = 'AbortError'; return error; };
    const getUrl = page => {
      const url = String(urlFor(page) || '');
      if (!url) throw new TypeError('A book page needs an image URL.');
      return url;
    };
    const detach = entry => {
      if (entry.timer) window.clearTimeout(entry.timer);
      entry.timer = null;
      if (entry.image) { entry.image.onload = null; entry.image.onerror = null; }
    };
    function makeEntry(page, url) {
      const entry = { page, url, state: 'queued', urgent: false, attempt: 0, image: null, timer: null };
      entry.promise = new Promise((resolve, reject) => { entry.resolve = resolve; entry.reject = reject; });
      // Background requests have no outside consumer. Consumers still receive the original rejection.
      entry.promise.catch(() => {});
      entries.set(url, entry);
      return entry;
    }
    function settleFailure(entry, error) {
      if (disposed || entry.state !== 'loading') return;
      detach(entry);
      if (entry.image) entry.image.src = '';
      loading.delete(entry);
      if (entry.attempt < 2 && (entry.urgent || desired.has(entry.url))) {
        entry.state = 'queued';
        if (entry.urgent) urgent.unshift(entry);
        else background.unshift(entry.url);
      } else {
        entry.state = 'error';
        entry.reject(error);
      }
      pump();
    }
    function start(entry) {
      entry.state = 'loading';
      entry.attempt += 1;
      const image = new window.Image();
      entry.image = image;
      loading.add(entry);
      image.decoding = 'async';
      image.fetchPriority = entry.urgent ? 'high' : 'low';
      entry.timer = window.setTimeout(() => {
        if (entry.image === image) settleFailure(entry, new Error('The book page took too long to load.'));
      }, timeout);
      image.onerror = () => {
        if (entry.image === image) settleFailure(entry, new Error('The book page could not be loaded.'));
      };
      image.onload = async () => {
        try {
          if (entry.image !== image) return;
          if (typeof image.decode === 'function') await image.decode();
          if (disposed || entry.state !== 'loading' || entry.image !== image) return;
          if ('naturalWidth' in image && image.naturalWidth === 0) throw new Error('The book page is empty.');
          detach(entry);
          loading.delete(entry);
          entry.state = 'ready';
          entry.resolve({ url: entry.url, image });
          pump();
        } catch (error) {
          // A decode from an earlier, timed-out attempt must not fail the replacement request.
          if (entry.image === image) settleFailure(entry, error);
        }
      };
      image.src = entry.url;
    }
    function takeUrgent() {
      while (urgent.length) {
        const entry = urgent.shift();
        if (entry.state === 'queued') return entry;
      }
      return null;
    }
    function takeBackground() {
      while (background.length) {
        const entry = entries.get(background.shift());
        if (entry && entry.state === 'queued' && !entry.urgent) return entry;
      }
      return null;
    }
    function pump() {
      if (disposed || pumping) return;
      pumping = true;
      try {
        while (loading.size < totalLimit) {
          let entry = takeUrgent();
          if (!entry) {
            const activeBackground = [...loading].filter(item => !item.urgent).length;
            if (document.hidden || activeBackground >= backgroundLimit) break;
            entry = takeBackground();
          }
          if (!entry) break;
          start(entry);
        }
      } finally { pumping = false; }
    }
    function ensure(page) {
      if (disposed) return Promise.reject(abortError('The book loader was disposed.'));
      let url;
      try { url = getUrl(page); } catch (error) { return Promise.reject(error); }
      let entry = entries.get(url);
      if (!entry || entry.state === 'error') entry = makeEntry(page, url);
      if (entry.state !== 'ready') {
        entry.urgent = true;
        if (entry.image) entry.image.fetchPriority = 'high';
        if (entry.state === 'queued' && !urgent.includes(entry)) urgent.push(entry);
        if (entry.state === 'queued' && loading.size >= totalLimit) {
          const obsolete = [...loading].reverse().find(item => !item.urgent);
          if (obsolete) {
            detach(obsolete);
            const image = obsolete.image;
            obsolete.image = null;
            obsolete.attempt = Math.max(0, obsolete.attempt - 1);
            loading.delete(obsolete);
            if (image) image.src = '';
            if (desired.has(obsolete.url)) {
              obsolete.state = 'queued';
              if (!background.includes(obsolete.url)) background.push(obsolete.url);
            } else {
              obsolete.state = 'cancelled';
              obsolete.reject(abortError('The pending background priority changed.'));
              entries.delete(obsolete.url);
            }
          }
        }
        pump();
      }
      return entry.promise;
    }
    function prioritize(pages) {
      if (disposed) return;
      urgent = [];
      for (const entry of entries.values()) {
        entry.urgent = false;
        if (entry.state === 'loading' && entry.image) entry.image.fetchPriority = 'low';
      }
      const next = [];
      const seen = new Set();
      for (const page of pages || []) {
        let url;
        try { url = getUrl(page); } catch (_) { continue; }
        if (seen.has(url)) continue;
        seen.add(url);
        let entry = entries.get(url);
        if (!entry) entry = makeEntry(page, url);
        // Failed background images wait for a deliberate ensure() retry, avoiding endless retries.
        if (entry.state === 'queued' && !entry.urgent) next.push(url);
      }
      desired = seen;
      for (const [url, entry] of entries) {
        if (entry.state === 'queued' && !entry.urgent && !seen.has(url)) {
          entry.state = 'cancelled';
          entry.reject(abortError('The pending background priority changed.'));
          entries.delete(url);
        }
      }
      background = next;
      pump();
    }
    const onVisibility = () => { if (!document.hidden) pump(); };
    document.addEventListener('visibilitychange', onVisibility);
    function dispose() {
      if (disposed) return;
      disposed = true;
      document.removeEventListener('visibilitychange', onVisibility);
      for (const entry of entries.values()) {
        detach(entry);
        if (entry.state !== 'ready' && entry.state !== 'error' && entry.state !== 'cancelled') {
          entry.state = 'cancelled';
          entry.reject(abortError('The book loader was disposed.'));
          if (entry.image) entry.image.src = '';
        }
      }
      entries.clear(); loading.clear(); urgent = []; background = []; desired.clear();
    }
    return { ensure, prioritize, dispose };
  }

  function visualClone(node) {
    const clone = node.cloneNode(true);
    const originals = node.matches && node.matches('img') ? [node] : [...node.querySelectorAll('img')];
    const images = clone.matches && clone.matches('img') ? [clone] : [...clone.querySelectorAll('img')];
    images.forEach((image, index) => {
      image.removeAttribute('srcset'); image.removeAttribute('sizes');
      image.src = originals[index].currentSrc || originals[index].src;
      image.loading = 'eager';
    });
    [clone, ...clone.querySelectorAll('[id]')].forEach(element => element.removeAttribute('id'));
    clone.setAttribute('aria-hidden', 'true');
    Object.assign(clone.style, { width: '100%', height: '100%', maxWidth: 'none', maxHeight: 'none', margin: '0', boxSizing: 'border-box', boxShadow: 'none' });
    return clone;
  }

  function turn(container, nextNodes, direction = 1, { spread = false, duration = 440 } = {}) {
    const previousTurn = turns.get(container);
    if (previousTurn) previousTurn();
    const nodes = Array.isArray(nextNodes) ? nextNodes : [nextNodes];
    const oldNodes = [...container.children];
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canAnimate = !reduced && direction && oldNodes.length && typeof container.animate === 'function';
    const bounds = container.getBoundingClientRect();
    const oldRects = oldNodes.map(node => node.getBoundingClientRect());
    const snapshots = canAnimate ? oldNodes.map(visualClone) : [];
    container.dataset.count = String(nodes.length);
    container.classList.toggle('is-single', nodes.length === 1);
    const frontCover = spread && nodes.length === 1 && Number(nodes[0].dataset.page || nodes[0].dataset.fptPage) === 1;
    const backCover = spread && nodes.length === 1 && !frontCover;
    container.style.setProperty('--frucare-shadow-duration', `${canAnimate ? duration : 0}ms`);
    container.style.setProperty('--frucare-shadow-left', frontCover ? '50%' : '0%');
    container.style.setProperty('--frucare-shadow-right', backCover ? '50%' : '0%');
    container.replaceChildren(...nodes);
    if (!canAnimate || bounds.width < 1 || bounds.height < 1) return Promise.resolve();
    const newRects = nodes.map(node => node.getBoundingClientRect());
    const forward = direction > 0;
    const activeIndex = forward ? oldNodes.length - 1 : 0;
    const rect = oldRects[activeIndex];
    const originalStyle = { position: container.style.position, perspective: container.style.perspective, isolation: container.style.isolation };
    if (window.getComputedStyle(container).position === 'static') container.style.position = 'relative';
    container.style.perspective = '1500px';
    container.style.isolation = 'isolate';
    const overlays = [];
    const concealed = [];
    const animations = [];
    const createLayer = pageRect => {
      const layer = document.createElement('div');
      layer.setAttribute('aria-hidden', 'true');
      layer.setAttribute('inert', '');
      layer.setAttribute('data-frucare-turn-layer', '');
      Object.assign(layer.style, {
        position: 'absolute', left: `${pageRect.left - bounds.left}px`, top: `${pageRect.top - bounds.top}px`,
        width: `${pageRect.width}px`, height: `${pageRect.height}px`, pointerEvents: 'none', zIndex: '4',
        margin: '0', boxSizing: 'border-box'
      });
      container.appendChild(layer); overlays.push(layer); return layer;
    };
    const front = createLayer(rect);
    Object.assign(front.style, { transformOrigin: forward ? 'left center' : 'right center', backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden', willChange: 'transform' });
    front.appendChild(snapshots[activeIndex]);
    if (spread) {
      const opposite = forward ? 0 : nodes.length - 1;
      const back = createLayer(newRects[opposite]);
      Object.assign(back.style, { transformOrigin: forward ? 'right center' : 'left center', backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden', willChange: 'transform', transform: `rotateY(${forward ? 180 : -180}deg)` });
      const reverseFace = visualClone(nodes[opposite]);
      reverseFace.style.visibility = 'visible';
      back.appendChild(reverseFace);
      concealed.push([nodes[opposite], nodes[opposite].style.visibility]);
      nodes[opposite].style.visibility = 'hidden';
      animations.push(back.animate([
        { transform: `rotateY(${forward ? 180 : -180}deg)` },
        { transform: 'rotateY(0deg)' }
      ], { duration, easing: 'cubic-bezier(.25,.65,.25,1)', fill: 'forwards' }));
      oldNodes.forEach((node, index) => {
        if (index === activeIndex) return;
        const stationary = createLayer(oldRects[index]);
        stationary.style.zIndex = '3'; stationary.appendChild(snapshots[index]);
      });
    }
    const shadow = document.createElement('div');
    Object.assign(shadow.style, { position: 'absolute', inset: '0', background: forward ? 'linear-gradient(90deg,rgba(40,25,12,.3),transparent 55%)' : 'linear-gradient(270deg,rgba(40,25,12,.3),transparent 55%)', pointerEvents: 'none', backfaceVisibility: 'hidden', opacity: '0' });
    front.appendChild(shadow);
    animations.push(shadow.animate([{ opacity: 0 }, { opacity: 0.9, offset: 0.45 }, { opacity: 0 }], { duration, fill: 'forwards' }));
    animations.push(front.animate(spread ? [
      { transform: 'rotateY(0deg)' },
      { transform: `rotateY(${forward ? -180 : 180}deg)` }
    ] : [
      { transform: 'scaleX(1)', opacity: 1 },
      { transform: 'scaleX(.06)', opacity: 0 }
    ], { duration, easing: 'cubic-bezier(.25,.65,.25,1)', fill: 'forwards' }));
    return new Promise(resolve => {
      let finished = false;
      let timer;
      const cleanup = () => {
        if (finished) return;
        finished = true;
        if (timer) window.clearTimeout(timer);
        concealed.forEach(([node, visibility]) => { node.style.visibility = visibility; });
        overlays.forEach(layer => layer.remove());
        animations.forEach(animation => animation.cancel());
        Object.assign(container.style, originalStyle);
        if (turns.get(container) === cleanup) turns.delete(container);
        resolve();
      };
      turns.set(container, cleanup);
      timer = window.setTimeout(cleanup, duration + 180);
      Promise.allSettled(animations.map(animation => animation.finished)).then(cleanup);
    });
  }

  window.FruCareBookRuntime = { version: 40, createQueue, orderPages, spreadPages, turn };
})(window);

if (!customElements.get('frucare-pairings')) {
  class FruCarePairings extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      try {
        this.pages = JSON.parse(this.querySelector('[data-fp-catalog]').textContent);
        this.words = JSON.parse(this.querySelector('[data-fp-translations]').textContent);
        if (this.pages.length !== 40) return;
      } catch { return; }
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.$ = selector => this.querySelector(selector);
      this.runtime = window.FruCareBookRuntime;
      this.desktop = window.matchMedia('(min-width: 900px)');
      this.viewer = this.$('[data-fp-viewer]');
      this.sheets = this.$('[data-fp-sheets]');
      this.dialog = this.$('[data-fp-dialog]');
      this.dialogSheets = this.$('[data-fp-dialog-sheets]');
      this.productImages = new Map();
      this.productUrls = new Map();
      this.pointerTimers = new Map();
      this.fitDialog = () => {
        if (!this.dialog.open) return;
        const area = this.$('[data-fp-dialog-scroll]');
        const spread = this.desktop.matches || (window.innerWidth > window.innerHeight && area.clientWidth >= 460 && area.clientHeight >= 180);
        const changed = this.dialogSpread !== spread;
        this.dialogSpread = spread;
        this.dialogSheets.dataset.spread = String(spread);
        const ratio = (spread ? 2000 : 1000) / 1410;
        const width = Math.max(0, Math.min(area.clientWidth, area.clientHeight * ratio));
        this.dialogSheets.style.setProperty('--fp-fit-width', width + 'px');
        this.dialogSheets.style.setProperty('--fp-fit-height', width / ratio + 'px');
        if (changed && this.currentPage) this.navigate(this.desiredPage || this.currentPage,0,false,true);
      };
      this.resizeObserver = new ResizeObserver(this.fitDialog);
      this.resizeObserver.observe(this.$('[data-fp-dialog-scroll]'));
      window.visualViewport?.addEventListener('resize', this.fitDialog, {signal});
      window.addEventListener('resize', this.fitDialog, {signal});
      this.queue = this.runtime.createQueue({urlFor: page => this.imageUrl(page), maxConcurrent: 2});
      this.zoomQueue = this.runtime.createQueue({urlFor: page => this.pages[page - 1].imageUrl, maxConcurrent: 2});
      this.currentPage = 0;
      this.desiredPage = this.hashPage() || 1;
      this.category = '';
      this.direction = 0;
      this.requestVersion = 0;
      this.querySelectorAll('[data-fp-enhance]').forEach(node => {node.hidden = false;});
      this.querySelectorAll('[data-fp-category]').forEach(button => button.addEventListener('click', () => this.filter(button.dataset.fpCategory), {signal}));
      for (const prefix of ['', 'dialog-']) {
        for (const [name, direction] of [['previous', -1], ['next', 1]]) {
          const button = this.$('[data-fp-' + prefix + name + ']');
          button.addEventListener('click', () => {
            button.classList.remove('is-pressed');
            void button.offsetWidth;
            button.classList.add('is-pressed');
            this.move(direction);
          }, {signal});
          button.addEventListener('animationend', () => button.classList.remove('is-pressed'), {signal});
        }
      }
      for (const surface of [this.viewer, this.dialog]) {
        surface.addEventListener('pointermove', event => {
          if (event.pointerType !== 'mouse') return;
          surface.classList.add('is-pointer-active');
          window.clearTimeout(this.pointerTimers.get(surface));
          this.pointerTimers.set(surface, window.setTimeout(() => surface.classList.remove('is-pointer-active'), 1200));
        }, {signal});
        surface.addEventListener('keydown', event => {
          if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target.closest('input,select,textarea,[contenteditable]')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.move(event.key === 'ArrowLeft' ? -1 : 1); }
        }, {signal});
      }
      this.bindSwipe(this.$('[data-fp-swipe]'), signal);
      this.bindSwipe(this.$('[data-fp-dialog-swipe]'), signal);
      this.bindDialogPages(signal);
      this.sheets.addEventListener('click', event => {
        const link = event.target.closest('[data-fp-zoom]');
        if (!link) return;
        if (Date.now() < (this.suppressClickUntil || 0)) {event.preventDefault(); return;}
        if (typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.openDialog(Number(link.dataset.page) || this.currentPage);
      }, {signal});
      this.$('[data-fp-zoom-open]').addEventListener('click',()=>this.openDialog(this.currentPage),{signal});
      this.$('[data-fp-dialog-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.bodyOverflow || '';
        this.dialogVersion = (this.dialogVersion || 0) + 1;
        this.wakePreparation?.();
        this.requestVersion++;
        this.pump();
        const focusTarget = this.dialogTrigger?.isConnected ? this.dialogTrigger : this.$('[data-fp-zoom-open]');
        focusTarget?.focus({preventScroll:true});
      }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r=this.dialog.getBoundingClientRect();
        if (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) this.dialog.close();
      }, {signal});
      this.$('[data-fp-download-language]')?.addEventListener('change', event => {
        const option = event.target.selectedOptions[0];
        const link = this.$('[data-frucare-download]');
        if (!option?.dataset.pdfUrl || !link) return;
        link.href = option.dataset.pdfUrl;
        link.hreflang = option.value;
        link.setAttribute('aria-label', link.textContent.trim() + ' (' + option.textContent.trim() + ')');
      }, {signal});
      window.addEventListener('hashchange', () => {
        const page = this.hashPage();
        if (page) {this.setCategory(''); this.navigate(page,0,false);}
      }, {signal});
      this.desktop.addEventListener('change', () => {
        this.fitDialog();
        this.navigate(this.desiredPage || this.currentPage,0,false,true);
      }, {signal});
      this.navigate(this.desiredPage,0,false);
    }
    disconnectedCallback() {
      this.wakePreparation?.();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.pointerTimers?.forEach(timer => window.clearTimeout(timer));
      if (this.dialog?.open) {this.dialog.close(); document.body.style.overflow = this.bodyOverflow || '';}
      this.queue?.dispose();
      this.zoomQueue?.dispose();
      this.initialized = false;
      this.requestVersion++;
    }
    imageUrl(number) {
      const url = new URL(this.pages[number - 1].imageUrl);
      const cssWidth = this.desktop.matches ? Math.min(430,(window.innerWidth-180)/2) : Math.max(240,window.innerWidth-96);
      const target=cssWidth*Math.min(window.devicePixelRatio || 1,2);
      url.searchParams.set('width',[360,540,720,1000].find(width=>width>=target)||1000);
      return url.href;
    }
    format(template, values) {return Object.entries(values).reduce((text,[key,value])=>text.replaceAll('__'+key+'__',String(value)),template);}
    visiblePages(page, zoom = this.dialog.open) {return this.runtime.spreadPages(page,zoom ? this.dialogSpread : this.desktop.matches,40);}
    hashPage() {
      const value=window.location.hash.match(/^#p=(\d{1,2})$/);
      const page=value?Number(value[1]):0;
      return page>=1 && page<=40?page:0;
    }
    setCategory(category) {
      this.category=category;
      this.querySelectorAll('[data-fp-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.fpCategory===category)));
    }
    filter(category) {
      this.setCategory(category);
      const selected=this.pages.find(page=>!category || page.category===category);
      if (selected) this.navigate(selected.page,0,true);
    }
    adjacent(page,direction) {
      const visible=this.visiblePages(page);
      const boundary=direction>0?Math.max(...visible):Math.min(...visible);
      const candidates=this.pages.filter(p=>direction>0?p.page>boundary:p.page<boundary);
      return direction>0?candidates[0]?.page:candidates.at(-1)?.page;
    }
    move(direction) {
      const next=this.adjacent(this.desiredPage||this.currentPage||1,direction);
      if (next) this.navigate(next,direction,true);
    }
    navigate(page,direction=0,updateHash=true,force=false) {
      if (!this.pages[page-1]) return;
      this.wakePreparation?.();
      this.desiredPage=page;
      this.direction=direction;
      this.updateHash=updateHash;
      this.forceRender=force || this.forceRender;
      this.requestVersion++;
      this.queue.prioritize(this.runtime.orderPages(page,40,direction));
      this.updateArrows(page);
      this.pump();
    }
    async prepare(numbers,zoom=false) {
      return Promise.all(numbers.map(async number=>{
        const item=await (zoom?this.zoomQueue:this.queue).ensure(number);
        const img=new Image();
        img.width=1000; img.height=1410; img.decoding='async'; img.draggable=false;
        img.className=zoom?'fp__dialog-image':'fp__page-image';
        img.alt=this.format(this.words.imageAlt,{TITLE:this.pages[number-1].title,PAGE:number});
        img.src=item.url;
        if (img.decode) await img.decode();
        if (zoom) {const leaf=document.createElement('div'); leaf.className='fp__leaf'; leaf.dataset.page=number; leaf.append(img); return leaf;}
        const link=document.createElement('a');
        link.className='fp__page-link'; link.dataset.fpZoom=''; link.dataset.page=number;
        link.href=this.pages[number-1].imageUrl; link.target='_blank'; link.rel='noopener';
        link.setAttribute('aria-label',this.words.zoom+' · '+this.pages[number-1].title);
        link.append(img);
        return link;
      }));
    }
    async pump() {
      if (this.running) return;
      this.running=true;
      try {
        while (this.initialized && (this.currentPage!==this.desiredPage || this.forceRender)) {
          const page=this.desiredPage, version=this.requestVersion, direction=this.currentPage?this.direction:0;
          const numbers=this.visiblePages(page,false), zoomNumbers=this.visiblePages(page,true), force=this.forceRender;
          this.viewer.setAttribute('aria-busy','true');
          this.$('[data-fp-image-error]').hidden=true;
          let nodes,zoomNodes;
          try {
            const superseded=new Promise(resolve=>{this.wakePreparation=()=>resolve(null);});
            if (this.dialog.open) this.zoomQueue.prioritize(zoomNumbers);
            const preparation=Promise.all([this.prepare(numbers),this.dialog.open?this.prepare(zoomNumbers,true):Promise.resolve(null)]);
            const ready=await Promise.race([preparation,superseded]);
            this.wakePreparation=null;
            if (!ready) continue;
            [nodes,zoomNodes]=ready;
          } catch {
            if (version===this.requestVersion) {
              this.$('[data-fp-image-error]').hidden=false;
              this.desiredPage=this.currentPage || page;
              this.forceRender=false;
              this.updateArrows(this.desiredPage);
              break;
            }
            continue;
          }
          if (!this.initialized || version!==this.requestVersion) continue;
          this.forceRender=false;
          this.currentPage=page;
          this.viewer.classList.toggle('is-single',numbers.length===1);
          this.commit(page,numbers,this.updateHash);
          this.viewer.setAttribute('aria-busy','false');
          const turns=[this.runtime.turn(this.sheets,nodes,force?0:direction,{spread:this.desktop.matches})];
          if (this.dialog.open && zoomNodes) {
            this.dialogVersion=(this.dialogVersion||0)+1;
            this.$('[data-fp-dialog-scroll]').scrollTop=0;
            turns.push(this.runtime.turn(this.dialogSheets,zoomNodes,force?0:direction,{spread:this.dialogSpread}));
          }
          this.queue.prioritize(this.runtime.orderPages(page,40,this.direction));
          await Promise.all(turns);
        }
      } finally {
        this.running=false;
        this.wakePreparation=null;
        this.viewer.setAttribute('aria-busy','false');
      }
    }
    count(numbers) {
      return numbers.length===2?this.format(this.words.spreadCount,{FROM:numbers[0],TO:numbers[1]}):this.format(this.words.pageCount,{PAGE:numbers[0]});
    }
    commit(page,numbers,updateHash) {
      this.$('[data-fp-count]').textContent=this.count(numbers);
      const dialogNumbers=this.visiblePages(page,true);
      this.$('[data-fp-dialog-title]').textContent=this.count(dialogNumbers);
      this.$('[data-fp-dialog-count]').textContent=dialogNumbers[0]+'/40';
      this.setCategory(this.pages[page-1].category==='Inleiding'?'':this.pages[page-1].category);
      this.updateArrows(this.desiredPage);
      const products=[...new Map(numbers.flatMap(n=>this.pages[n-1].products).map(p=>[p.handle,p])).values()];
      this.$('[data-fp-products-wrap]').hidden=!products.length;
      this.$('[data-fp-products]').replaceChildren(...products.map(product=>{
        const link=document.createElement('a');
        link.className='fp__product-link';
        link.href=this.dataset.rootUrl.replace(/\/$/,'')+'/products/'+encodeURIComponent(product.handle);
        link.setAttribute('aria-label',this.format(this.words.shopProduct,{PRODUCT:product.label}));
        const label=document.createElement('span'); label.lang=this.dataset.bookLocale; label.textContent=product.label;
        const arrow=document.createElement('span'); arrow.textContent='↗'; arrow.setAttribute('aria-hidden','true');
        const thumbnail=document.createElement('span'); thumbnail.className='fp__product-thumbnail-slot'; thumbnail.setAttribute('aria-hidden','true');
        link.append(thumbnail,label,arrow);
        this.addProductImage(product.handle, link);
        return link;
      }));
      this.$('[data-fp-book-text]').textContent=numbers.map(n=>this.pages[n-1].searchableText).join('\n\n');
      if (updateHash) {const url=new URL(window.location.href); url.hash='p='+String(page).padStart(2,'0'); window.history.replaceState(window.history.state,'',url);}
    }
    updateArrows(page) {
      for (const prefix of ['','dialog-']) {
        this.$('[data-fp-'+prefix+'previous]').disabled=!this.adjacent(page,-1);
        this.$('[data-fp-'+prefix+'next]').disabled=!this.adjacent(page,1);
      }
    }
    async productImage(handle) {
      if (this.productImages.has(handle)) return this.productImages.get(handle);
      const productPath=this.dataset.rootUrl.replace(/\/$/,'')+'/products/'+encodeURIComponent(handle);
      let path=productPath+'.js';
      let resolved=false;
      const pending=(async()=>{
        for (let attempt=0;attempt<3;attempt++) {
          try {
            const response=await fetch(path,{signal:this.controller.signal,cache:'no-cache'});
            if (response.status===404 && !resolved) {
              resolved=true;
              const productPage=await fetch(productPath,{signal:this.controller.signal,cache:'no-cache'});
              if (!productPage.ok) throw new Error('Product unavailable');
              const effectiveUrl=new URL(productPage.url,window.location.origin);
              if (effectiveUrl.origin!==window.location.origin || !effectiveUrl.pathname.includes('/products/')) throw new Error('Product unavailable');
              effectiveUrl.pathname=effectiveUrl.pathname.replace(/\/$/,'');
              effectiveUrl.search=''; effectiveUrl.hash='';
              this.productUrls.set(handle,effectiveUrl.href);
              path=effectiveUrl.pathname+'.js';
              continue;
            }
            if (!response.ok) throw new Error('Product unavailable');
            const product=await response.json();
            const image=product.featured_image || product.images?.[0];
            const source=typeof image==='string'?image:image?.src;
            if (!source) throw new Error('Product image unavailable');
            return source;
          } catch (error) {
            if (this.controller.signal.aborted) return null;
            if (attempt<2) await new Promise(resolve=>window.setTimeout(resolve,300*(attempt+1)));
          }
        }
        return null;
      })();
      this.productImages.set(handle,pending);
      const source=await pending;
      if (!source) this.productImages.delete(handle);
      return source;
    }
    async addProductImage(handle, link) {
      const source=await this.productImage(handle);
      if (!source || !link.isConnected) return;
      if (this.productUrls.has(handle)) link.href=this.productUrls.get(handle);
      const url=new URL(source,window.location.origin);
      url.searchParams.set('width','96');
      const image=new Image(42,42);
      image.className='fp__product-thumbnail'; image.alt=''; image.decoding='async';
      image.addEventListener('error',()=>{
        this.productImages.delete(handle);
        if (image.dataset.retried) {image.remove();return;}
        image.dataset.retried='true';
        image.src=new URL(source,window.location.origin).href;
      });
      image.src=url.href;
      link.querySelector('.fp__product-thumbnail-slot')?.replaceChildren(image);
    }
    openDialog(page) {
      if (!this.currentPage) return;
      this.dialogTrigger=document.activeElement;
      this.bodyOverflow=document.body.style.overflow;
      document.body.style.overflow='hidden';
      this.dialogSheets.replaceChildren(...[...this.sheets.children].filter(n=>n.dataset.page).map(n=>{const leaf=document.createElement('div');leaf.className='fp__leaf';leaf.dataset.page=n.dataset.page;leaf.append(n.querySelector('img').cloneNode());return leaf;}));
      this.dialogSheets.dataset.count=this.visiblePages(this.currentPage,false).length;
      this.dialog.showModal();
      this.fitDialog();
      this.$('[data-fp-dialog-scroll]').scrollTop=0;
      this.navigate(page,0,false,true);
    }
    bindDialogPages(signal) {
      let pressed=null;
      const leafAt=event=>{
        const leaf=event.target.closest?.('.fp__leaf[data-page]');
        return leaf?.parentElement===this.dialogSheets && !event.target.closest('button,a,input,select,textarea,[contenteditable]')?leaf:null;
      };
      this.dialogSheets.addEventListener('pointerdown',event=>{
        const leaf=leafAt(event);
        pressed=this.dialog.open && leaf && event.pointerType==='mouse' && event.button===0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey?{leaf,x:event.clientX,y:event.clientY}:null;
      },{signal});
      this.dialogSheets.addEventListener('pointercancel',()=>{pressed=null;},{signal});
      this.dialogSheets.addEventListener('touchstart',()=>{pressed=null;},{signal,passive:true});
      this.dialogSheets.addEventListener('click',event=>{
        const down=pressed;
        pressed=null;
        if (!down || !this.dialog.open || event.defaultPrevented || event.detail===0 || event.button!==0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || (event.pointerType && event.pointerType!=='mouse') || event.sourceCapabilities?.firesTouchEvents || Date.now()<(this.suppressClickUntil||0)) return;
        const leaf=leafAt(event);
        if (leaf!==down.leaf || Math.hypot(event.clientX-down.x,event.clientY-down.y)>8) return;
        const rect=leaf.getBoundingClientRect();
        if (event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) return;
        const page=Number(leaf.dataset.page), bounds=this.dialogSheets.getBoundingClientRect();
        const direction=page===1?1:page===40?-1:this.dialogSpread?(rect.left+rect.width/2<bounds.left+bounds.width/2?-1:1):(event.clientX<rect.left+rect.width/2?-1:1);
        event.preventDefault();
        this.move(direction);
      },{signal});
    }
    bindSwipe(surface,signal) {
      let start=null;
      surface.addEventListener('touchstart',event=>{start=event.touches.length===1 && (window.visualViewport?.scale||1)<=1.05 && !event.target.closest('button')?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null;},{signal,passive:true});
      surface.addEventListener('touchmove',event=>{if(event.touches.length!==1)start=null;},{signal,passive:true});
      surface.addEventListener('touchend',event=>{if(!start||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.7){this.suppressClickUntil=Date.now()+600;this.move(dx<0?1:-1);}},{signal,passive:true});
      surface.addEventListener('touchcancel',()=>{start=null;},{signal,passive:true});
    }
  }
  customElements.define('frucare-pairings',FruCarePairings);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frucare-partners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('frucare-display-gallery')) {
    customElements.define('frucare-display-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        this.openers = [...this.querySelectorAll('[data-display-open]')];
        if (!this.dialog || !this.openers.length || !this.dialog.showModal) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.image = this.querySelector('[data-display-image]');
        this.caption = this.querySelector('[data-display-caption]');
        this.position = this.querySelector('[data-display-position]');
        this.stage = this.querySelector('[data-display-stage]');
        this.openers.forEach((opener, index) => opener.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          if (this.dialog.open) return;
          this.opener = opener;
          this.showImage(index);
          this.scrollState = { body: document.body.style.overflow, root: document.documentElement.style.overflow };
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          document.documentElement.style.overflow = 'hidden';
          this.querySelector('[data-display-close]').focus({ preventScroll: true });
        }, options));
        this.querySelector('[data-display-close]').addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.dialog.close();
        }, options);
        this.querySelector('[data-display-prev]').addEventListener('click', () => this.showImage(this.index - 1), options);
        this.querySelector('[data-display-next]').addEventListener('click', () => this.showImage(this.index + 1), options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'Tab') {
            const controls = [...this.dialog.querySelectorAll('button')].filter(button => !button.hidden && !button.disabled);
            if (!controls.length) return;
            event.preventDefault();
            event.stopPropagation();
            const current = controls.indexOf(document.activeElement);
            const next = current < 0 ? (event.shiftKey ? controls.length - 1 : 0) : (current + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
            controls[next].focus({ preventScroll: true });
            return;
          }
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          event.stopPropagation();
          this.showImage(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        document.addEventListener('focusin', event => {
          if (this.dialog.open && !this.dialog.contains(event.target)) this.querySelector('[data-display-close]').focus({ preventScroll: true });
        }, { ...options, capture: true });
        this.dialog.addEventListener('pointerdown', event => {
          this.backdropPress = event.target === this.dialog;
          if (this.backdropPress) event.stopPropagation();
        }, options);
        this.dialog.addEventListener('click', event => {
          event.stopPropagation();
          if (event.target !== this.dialog || !this.backdropPress) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.restorePage(), options);
        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.swipe = { x: event.clientX, y: event.clientY, id: event.pointerId };
          this.stage.setPointerCapture(event.pointerId);
        }, options);
        this.stage.addEventListener('pointerup', event => {
          const swipe = this.swipe;
          this.swipe = null;
          if (!swipe || swipe.id !== event.pointerId) return;
          const dx = event.clientX - swipe.x;
          const dy = event.clientY - swipe.y;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
          event.preventDefault();
          this.showImage(this.index + (dx < 0 ? 1 : -1));
        }, options);
        this.stage.addEventListener('pointercancel', () => { this.swipe = null; }, options);
        this.stage.addEventListener('dragstart', event => event.preventDefault(), options);
        if (this.openers.length < 2) {
          this.querySelector('[data-display-prev]').hidden = true;
          this.querySelector('[data-display-next]').hidden = true;
        }
      }
      showImage(index) {
        this.index = (index + this.openers.length) % this.openers.length;
        const opener = this.openers[this.index];
        const thumbnail = opener.querySelector('img');
        this.image.width = Number(opener.dataset.displayWidth);
        this.image.height = Number(opener.dataset.displayHeight);
        this.image.src = thumbnail.currentSrc || thumbnail.src;
        this.image.alt = thumbnail.alt;
        this.caption.textContent = opener.closest('figure').querySelector('figcaption').textContent;
        this.position.textContent = this.dataset.positionLabel.replace('[current]', this.index + 1).replace('[total]', this.openers.length);
        const request = this.imageRequest = (this.imageRequest || 0) + 1;
        const fullImage = new Image();
        fullImage.onload = () => {
          if (this.dialog.open && this.imageRequest === request) this.image.src = opener.href;
        };
        fullImage.src = opener.href;
      }
      restorePage() {
        if (this.scrollState) {
          document.body.style.overflow = this.scrollState.body;
          document.documentElement.style.overflow = this.scrollState.root;
          this.scrollState = null;
        }
        this.swipe = null;
        this.backdropPress = false;
        this.imageRequest = (this.imageRequest || 0) + 1;
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.restorePage();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frucare-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('frucare-reviews')) {
    class FruCareReviews extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-review-track]');
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        if (!this.track || !this.cards.length) return;
        this.controller = new AbortController();
        this.status = this.querySelector('[data-review-status]');
        this.playButton = this.querySelector('[data-review-play]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Math.max(8000, (Number(this.dataset.interval) || 9) * 1000);
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.manual = false;
        this.index = 0;
        this.listen(this.querySelector('[data-review-prev]'), 'click', () => this.move(-1, true));
        this.listen(this.querySelector('[data-review-next]'), 'click', () => this.move(1, true));
        this.listen(this.querySelector('[data-review-side-prev]'), 'click', () => this.move(-1, true));
        this.listen(this.querySelector('[data-review-side-next]'), 'click', () => this.move(1, true));
        this.listen(this.playButton, 'click', () => {
          this.paused = !this.paused;
          this.updatePlayButton();
          this.schedule();
        });
        this.listen(this.track, 'pointerdown', () => this.manualInteraction(), { passive: true });
        this.listen(this.track, 'wheel', () => this.manualInteraction(), { passive: true });
        this.listen(this.track, 'keydown', event => this.keydown(event));
        this.listen(this.track, 'scroll', () => {
          clearTimeout(this.timer);
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settled(), 160);
        }, { passive: true });
        this.listen(this, 'pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        });
        this.listen(this, 'pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.schedule();
        });
        this.listen(this, 'focusin', () => {
          this.focused = true;
          this.schedule();
        });
        this.listen(this, 'focusout', event => {
          this.focused = !!event.relatedTarget && this.contains(event.relatedTarget);
          this.schedule();
        });
        this.listen(this, 'toggle', () => this.schedule(), { capture: true });
        this.listen(document, 'visibilitychange', () => this.schedule());
        this.listen(this.motion, 'change', () => {
          if (this.motion.matches) this.paused = true;
          this.updatePlayButton();
          this.schedule();
        });
        this.listen(document, 'shopify:block:select', event => {
          const card = event.target.closest('[data-review-card]');
          const index = this.cards.indexOf(card);
          if (index < 0) return;
          this.paused = true;
          this.updatePlayButton();
          this.goTo(index, true);
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.schedule();
          }, { threshold: 0.15 });
          this.observer.observe(this);
        } else {
          this.visible = true;
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.settled());
          this.resizeObserver.observe(this.track);
        }
        this.querySelector('[data-review-controls]').hidden = this.cards.length < 2;
        this.setAttribute('data-review-ready', '');
        this.updatePlayButton();
        if (this.inset() > 2 && this.cards.length > 3) this.goTo(1, false, 'auto');
        this.settled();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
      }

      listen(target, type, handler, options = {}) {
        target?.addEventListener(type, handler, { ...options, signal: this.controller.signal });
      }

      manualInteraction() {
        this.manual = true;
        this.announce = true;
        this.schedule();
      }

      keydown(event) {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1, true);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1, true);
        }
      }

      move(direction, manual) {
        const atEnd = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 4;
        const atStart = this.track.scrollLeft <= 4;
        let next = this.index + direction;
        if (direction > 0 && atEnd) next = 0;
        if (direction < 0 && atStart) next = this.cards.length - 1;
        this.goTo(next, manual);
      }

      inset() {
        return parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart) || 2;
      }

      goTo(index, manual, behavior) {
        const next = Math.max(0, Math.min(this.cards.length - 1, index));
        this.manual = manual;
        this.announce = manual;
        clearTimeout(this.timer);
        const trackBox = this.track.getBoundingClientRect();
        const cardBox = this.cards[next].getBoundingClientRect();
        this.track.scrollTo({
          left: this.track.scrollLeft + cardBox.left - trackBox.left - this.inset(),
          behavior: behavior || (this.motion.matches ? 'auto' : 'smooth')
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settled(), 180);
      }

      settled() {
        const start = this.track.getBoundingClientRect().left + this.inset();
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const candidate = Math.abs(card.getBoundingClientRect().left - start);
          if (candidate < distance) {
            distance = candidate;
            this.index = index;
          }
        });
        const label = this.dataset.positionLabel.replace('[current]', String(this.index + 1));
        if (this.announce) this.status.textContent = label;
        this.announce = false;
        this.schedule();
      }

      readingTime() {
        const viewport = this.track.getBoundingClientRect();
        const words = this.cards.reduce((longest, card) => {
          const box = card.getBoundingClientRect();
          const overlap = Math.min(box.right, viewport.right) - Math.max(box.left, viewport.left);
          if (overlap < box.width * 0.75) return longest;
          const text = card.querySelector('[data-review-text]')?.textContent.trim() || '';
          return Math.max(longest, text.split(/\s+/u).filter(Boolean).length);
        }, 0);
        return Math.max(this.interval, 3000 + words * 300);
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.controller || this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.cards.length < 2 || this.track.scrollWidth <= this.track.clientWidth + 4 || this.querySelector('[data-review-original][open]')) return;
        const delay = this.readingTime() * (this.manual ? 2 : 1);
        this.timer = setTimeout(() => {
          this.manual = false;
          this.move(1, false);
        }, delay);
      }

      updatePlayButton() {
        if (!this.playButton) return;
        this.playButton.setAttribute('aria-pressed', String(this.paused));
        this.playButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.playButton.querySelector('[data-review-play-label]').textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      }
    }
    customElements.define('frucare-reviews', FruCareReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
